import CommercialSvg from "./commercialSvg";
import MovableSvg from "./movableSvg";
import ResidentialSvg from "./residentialSvg";
import ExpertSvg from "./expertSvg";
import FinancingSvg from "./financingSvg";
import { HeartIcon, UserIcon } from "@heroicons/react/outline";

import RelationalManagerSvg from "./relationalManagerSvg";

export default function HeaderNavItems() {
  const navigation = {
    main: [
      {
        label: "Home",
        value: "home",
        link: "/",
        dropdown: false,
        active: false,
      },
      {
        label: <a href="/auction-properties">Properties</a>,
        value: "properties",
        link: "/auction-properties",
        dropdown: true,
        active: false,
      },
      // {
      //   label: <a href="/services">Services</a>,
      //   value: "services",
      //   link: "#",
      //   dropdown: true,
      //   active: false,
      // },
      // {
      //   label: "Subscription",
      //   value: "subscription",
      //   link: "/subscription",
      //   dropdown: false,
      //   active: false,
      // },
      {
        label: "Blogs",
        value: "blogs",
        link: "/blogs",
        dropdown: false,
        active: false,
      },
      {
        label: "Contact",
        value: "contact",
        link: "/contactus",
        dropdown: false,
        active: false,
      },
      {
        label: "Profile",
        value: "profile",
        link: "/dashboard/profile",
        dropdown: false,
        active: false,
      },
    ],
    properties: [
      {
        name: "Residential Assets",
        label: (
          <div className="flex items-center gap-x-2">
            <ResidentialSvg /> Residential Assets
          </div>
        ),
        value: "residential",
        href: "/residential-auction-properties?start_from=asset-type",
        children: [
          {
            label: "Plot Residential",
            href: "/residential-plot-residential-auction-properties?start_from=asset-type",
            value: "plot-residential",
            active: false,
          },
          {
            label: "Individual House",
            href: "/residential-individual-house-auction-properties?start_from=asset-type",
            value: "individual-house",
            active: false,
          },
          {
            label: "Flat",
            href: "/residential-flat-auction-properties?start_from=asset-type",
            value: "flat",
            active: false,
          },
          {
            label: "Bungalow",
            href: "/residential-bungalow-auction-properties?start_from=asset-type",
            value: "bungalow",
            active: false,
          },
          {
            label: "Farm House",
            href: "/residential-farm-house-auction-properties?start_from=asset-type",
            value: "farm-house",
            active: false,
          },
          {
            label: "Villa",
            href: "/residential-villa-auction-properties?start_from=asset-type",
            value: "villa",
            active: false,
          },
        ],
      },
      {
        name: "Commercial Assets",
        label: (
          <div className="flex items-center gap-x-2">
            <CommercialSvg /> Commercial Assets
          </div>
        ),
        value: "commercial",
        href: "/commercial-auction-properties?start_from=asset-type",
        children: [
          {
            label: "Plot Commercial",
            href: "/commercial-plot-commercial-auction-properties?start_from=asset-type",
            value: "plot-commercial",
            active: false,
          },
          {
            label: "Malls",
            href: "/commercial-malls-auction-properties?start_from=asset-type",
            value: "malls",
            active: false,
          },
          {
            label: "Office",
            href: "/commercial-office-auction-properties?start_from=asset-type",
            value: "office",
            active: false,
          },
          {
            label: "Shops",
            href: "/commercial-shops-auction-properties?start_from=asset-type",
            value: "shops",
            active: false,
          },
          {
            label: "Shop",
            href: "/commercial-shop-1-auction-properties?start_from=asset-type",
            value: "shop-1",
            active: false,
          },
          {
            label: "Others",
            href: "/commercial-others-1-auction-properties?start_from=asset-type",
            value: "others-1",
            active: false,
          },
        ],
      },
      {
        name: "Industrial Assets",
        label: (
          <div className="flex items-center gap-x-2">
            <MovableSvg /> Industrial Assets
          </div>
        ),
        value: "industrial",
        href: "/industrial-auction-properties?start_from=asset-type",
        children: [
          {
            label: "Godowns",
            href: "/industrial-godowns-auction-properties?start_from=asset-type",
            value: "godowns",
            active: false,
          },
          {
            label: "Plant and Machinery",
            href: "/industrial-plant-and-machinery-auction-properties?start_from=asset-type",
            value: "plant-and-machinery",
            active: false,
          },
          {
            label: "Godown",
            href: "/industrial-godown-1-auction-properties?start_from=asset-type",
            value: "godown-1",
            active: false,
          },
          {
            label: "Goods",
            href: "/industrial-goods-auction-properties?start_from=asset-type",
            value: "goods",
            active: false,
          },
          {
            label: "Plot Industrial",
            href: "/industrial-plot-industrial-auction-properties?start_from=asset-type",
            value: "plot-industrial",
            active: false,
          },
          {
            label: "Shed with Plant and Machinery",
            href: "/industrial-shed-with-plant-and-machinery-auction-properties?start_from=asset-type",
            value: "shed-with-plant-and-machinery",
            active: false,
          },
          {
            label: "Industrial Shed",
            href: "/industrial-industrial-shed-auction-properties?start_from=asset-type",
            value: "industrial-shed",
            active: false,
          },
          {
            label: "Industrial Plot",
            href: "/industrial-industrial-plot-auction-properties?start_from=asset-type",
            value: "industrial-plot",
            active: false,
          },
          {
            label: "Industrial Land",
            href: "/industrial-industrial-land-auction-properties?start_from=asset-type",
            value: "industrial-land",
            active: false,
          },
        ],
      },
    ],
    // services: [
    //   {
    //     label: (
    //       <div className="flex items-center gap-x-2">
    //         <ExpertSvg /> Expert Consultation
    //       </div>
    //     ),
    //     href: "/services#expert-consulting",
    //     active: false,
    //   },
    //   {
    //     label: (
    //       <div className="flex items-center gap-x-2">
    //         <FinancingSvg /> Financing Assistance
    //       </div>
    //     ),
    //     href: "/services#financing-assistance",
    //     active: true,
    //   },
    //   {
    //     label: (
    //       <div className="flex items-center gap-x-2 truncate pr-10">
    //         <RelationalManagerSvg /> Dedicated Relationship Manager
    //       </div>
    //     ),
    //     href: "/services#dedicated-relationship-manager",
    //     active: false,
    //   },
    // ],
    profile: [
      {
        label: (
          <div className="flex justify-between items-center w-32">
            <span className="flex"> Shortlisted</span>{" "}
            <HeartIcon height="20" width="20" className="ml-2" />
          </div>
        ),
        href: "/dashboard/shortlisted",
        active: false,
      },
      {
        label: (
          <div className="flex justify-between items-center w-32">
            <span className="flex grow"> Profile</span>
            <UserIcon height="20" width="20" className="ml-2" />
          </div>
        ),
        href: "/dashboard/profile",
        active: true,
      },
      {
        label: (
          <div className="flex items-center w-32 truncate pr-10">Logout</div>
        ),
        href: "/",
        active: false,
      },
    ],
  };
  return navigation;
}
